





















import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    }
  }
})
export default class Switcher extends Vue {
  toggle () {
    if (this.$props.disabled) {
      return
    }
    this.$emit('input', !this.$props.value)
    this.$emit('change', !this.$props.value)
  }
}
